interface IlustracionDeTarjetaProps {
  readonly src: string;
  readonly className?: string;
}

/** Ilustración decorativa: el texto visible de la tarjeta sigue siendo su nombre accesible. */
export function IlustracionDeTarjeta({ src, className }: IlustracionDeTarjetaProps) {
  const clase = ["opcion__ilustracion", className].filter(Boolean).join(" ");

  return (
    <span className={clase} aria-hidden="true">
      <img src={src} alt="" width={768} height={768} loading="lazy" decoding="async" draggable={false} />
    </span>
  );
}
